"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FilterField_ClearAll: "Clear all",
            FilterField_ShowLessValues: "Show less",
            FilterField_ShowMoreValues: "Show {0} more"
        }
    });
    var controls;
    (function (controls) {
        var IsOneOfFilterFieldContent = /** @class */ (function (_super) {
            __extends(IsOneOfFilterFieldContent, _super);
            function IsOneOfFilterFieldContent(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /**
                 * Toggles the value indicating whether capping of the value pills should occur.
                 * @internal
                 */
                _this.ToggleCapping = function () {
                    $dyn.setValue(_this, "ShouldCap", !$dyn.value(_this.ShouldCap));
                };
                /**
                 * Paste handler method. Used by task recorder to record pasting values.
                 * @internal
                 * @param args The function arguments.
                 */
                _this.OnPasteValue = function (args) {
                    if (args.length !== 2) {
                        return;
                    }
                    _this.FilterField.Values.push(args[1]);
                    // TODO: Deliverable 259153
                };
                /**
                 * Clears all the filter values.
                 * @internal
                 */
                _this.ClearAllValues = function () {
                    _this.Values.splice(0);
                    _this.FocusInput();
                };
                _this.Element = element;
                // FilterField extends $dyn.ui.Control and parent is container and hence we have to cast as any first.
                _this.FilterField = parent;
                _this.Values = (_this.FilterField && _this.FilterField.Values) || $dyn.observableObject($dyn.observable([]));
                _this.ShouldCap = $dyn.observable(true);
                _this.CombinedValue = $dyn.computed(function () {
                    return "";
                }, function (value) {
                    // Get the array of values to append
                    var values = ($dyn.value(value) || "").split(",");
                    // Append the values onto the end of the current values
                    if ($dyn.value(_this.FilterField.ContainsMoreThanEmptyValue)) {
                        values = $dyn.value(_this.Values).map(function (val) {
                            return $dyn.value(val);
                        }).concat(values);
                    }
                    // Remove all former entries and append all current entries. Note that we don't call splice on the observable array directly since we need a
                    // single array of arguments (e.g. the items to be added are part of a variable argument list). Because of that we instead combine the start
                    // index, number of items to remove, and variable argument list of items to add into a single array.
                    var spliceArgs = [
                        // Start from the first index
                        0,
                        // Indicate all entries should be removed
                        $dyn.length(_this.Values)
                        // Include the values that should be added to the 'Values' array
                        // Casting as any is required else concat is taking the type as number because of splice operation
                    ];
                    spliceArgs = spliceArgs.concat($dyn.util.removeDuplicateOrEmptyStringArrayEntries(values));
                    _this.Values.splice.apply(_this.Values, spliceArgs);
                    // Clear any uncommitted values within the input as is needed when the user selects a value
                    // during a loopup, otherwise the uncommitted value won't be cleared. This is due to the fact
                    // that this computed property always returns the same empty string, regardless of underlying
                    // values.
                    if (_this.InputContext && _this.InputContext.uncommittedValue) {
                        _this.InputContext.uncommittedValue = undefined;
                    }
                });
                _this.CappedValues = $dyn.computed(function () {
                    var values = $dyn.value(_this.Values);
                    if ($dyn.value(_this.ShouldCap)) {
                        values = values.slice(0, $dyn.controls.IsOneOfFilterFieldContent.MaxPillsToDisplay);
                    }
                    return values;
                });
                _this.ContainsMoreThanCanBeDisplayed = $dyn.computed(function () {
                    return $dyn.length(_this.Values) > $dyn.controls.IsOneOfFilterFieldContent.MaxPillsToDisplay;
                });
                _this.CappingToggleButtonText = $dyn.computed(function () {
                    return $dyn.value(_this.ShouldCap) ? $dyn.format($dyn.label("FilterField_ShowMoreValues"), $dyn.length(_this.Values) - $dyn.controls.IsOneOfFilterFieldContent.MaxPillsToDisplay) : $dyn.label("FilterField_ShowLessValues");
                });
                _this.CappingToggleButtonHelpText = $dyn.computed(function () {
                    return $dyn.value(_this.ShouldCap) ?
                        $dyn.value(_this.Values).slice($dyn.controls.IsOneOfFilterFieldContent.MaxPillsToDisplay).map(function (value) {
                            return $dyn.value(value);
                        }).join(", ") : "";
                });
                _this.CappingToggleButtonSymbol = $dyn.computed(function () {
                    return $dyn.value(_this.ShouldCap) ? "ChevronDown" : "ChevronUp";
                });
                return _this;
            }
            Object.defineProperty(IsOneOfFilterFieldContent.prototype, "InputControl", {
                /** The input control element. */
                get: function () {
                    if (!this._inputControl) {
                        this._inputControl = this.Element.querySelector("input");
                    }
                    return this._inputControl;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(IsOneOfFilterFieldContent.prototype, "InputContext", {
                /** The input control context. */
                get: function () {
                    if (!this._inputContext) {
                        this._inputContext = $dyn.context(this.InputControl);
                    }
                    return this._inputContext;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Sets focus to the input element.
             * @internal
             */
            IsOneOfFilterFieldContent.prototype.FocusInput = function () {
                if (this.InputControl) {
                    this.InputControl.focus();
                }
            };
            return IsOneOfFilterFieldContent;
        }($dyn.ui.Control));
        controls.IsOneOfFilterFieldContent = IsOneOfFilterFieldContent;
        (function (IsOneOfFilterFieldContent) {
            IsOneOfFilterFieldContent.MaxPillsToDisplay = 5;
        })(IsOneOfFilterFieldContent = controls.IsOneOfFilterFieldContent || (controls.IsOneOfFilterFieldContent = {}));
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=IsOneOfFilterFieldContent.js.map
